export const environment = {
    production: true,
    locales: '',
    APIEndpoint: ''
};
